export enum AccountStatus {
  UNKNOWN = 0,
  LOGGED_IN = 1,
  NOT_LOGGED_IN = 2,
}
